export const cardProtectionPlusGroupCodes = ["1000001429"];
